module.exports = __webpack_public_path__ + "src/assets/images/icon-pipeline-summary-docs.png?e5804a3fc887bccf60624be0a783e17b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-pipeline-summary-docs.png
// module id = 1006
// module chunks = 1